import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import {LoadingBar} from "../../../components/Loader";
import Thumb from "../../../components/Thumb";
import Pagination from "../../../components/Pagination";
import {fetchMedias, resetMedias} from "../../../../creators/medias";
import Aqp from "../../../../libs/mk-react-aqp";
import createLink from "../../../../libs/createLink";
import {fetchMediasTag, resetMediasTag} from "../../../../creators/medias.tag";
import {Button} from "../../../components/Button";
import Helmet from "react-helmet";
import {canonical} from "../../../../libs/helper";


class Medias extends React.Component {
    constructor(props) {
        super(props);
        this.props.resetMedias();
        this.props.resetMediasTag();
        this.filter = {
            limit: (this.props.slugUser && !this.props.showAll) ? 15 : 30,
            sort: 0,
            page: 1,
            kind: this.props.type,
            tags : this.props.tag._id
        };
        if(this.props.slugUser && !this.props.showAll){
            this.filter = {
                ...this.filter,
                "owner.slug!" : this.props.slugUser
            }
        }
        if(this.props.slugUser && this.props.showAll){
            this.filter = {
                ...this.filter,
                "owner.slug" : this.props.slugUser
            }
        }
        this.aqp = new Aqp({}, {
            blacklist: ['limit', 'page', 'kind'],
            currentLink: createLink(this.props.type === "video" ? "tagVideo" : "tagPhoto", {tag : this.props.tag, slug : this.props.slugUser, showAll : this.props.showAll}),
            filterDefault: this.filter
        });
        this.state = {
            filter: {...this.filter, ...this.aqp.query, page: this.props.match.params.page || 1},
        };

        this.handleChangePage = this.handleChangePage.bind(this);
        if(this.props.slugUser && !this.props.showAll){
            this.getMediasTag({
                ...this.state.filter,
                limit : 15,
                page : 1,
                "owner.slug" : this.props.slugUser
            });
        }
        this.getMedias(this.state.filter);

    }

    getMediasTag(filter) {
        let query = {...filter};
        this.props.fetchMediasTag(query);
    }

    getMedias(filter) {
        let query = {...filter};
        this.props.fetchMedias(this.aqp.set(query));
    }

    handleChangePage(page) {
        let filter = {...this.state.filter, page};
        this.setState({filter});
        this.getMedias(filter);
        window.scrollTo(0, 0);
    }

    render() {
        let totalPage = this.props.medias ? Math.ceil(this.props.mediasTotal / this.state.filter.limit) : 0;
        let url = createLink(this.props.type === "video" ? "tagVideo" : "tagPhoto", {tag : this.props.tag, showAll :true});
        let currentPage = parseInt(this.state.filter.page);
        return (
        <div className="container">
            <Helmet>
                <title>{(this.props.tag && this.props.tag.infos && this.props.tag.infos[this.props.type] && this.props.tag.infos[this.props.type].title) || this.props.metaHelmet().title }</title>
                <meta name="description" content={(this.props.tag && this.props.tag.infos && this.props.tag.infos[this.props.type] && this.props.tag.infos[this.props.type].description) || this.props.metaHelmet().description } />
                <meta name="robots" content="noindex" />
                {currentPage === 2 && (<link rel="prev" href={canonical(url, "", "tags")}/>)}
                {currentPage >= 3 && (<link rel="prev" href={`${canonical(`${url}/${(currentPage - 1)}`, "", "tags")}`} />)}
                <link rel="canonical" href={currentPage >1 ? `${canonical(`${url}/${currentPage}`, "", "tags")}` : canonical(url, "", "tags")} />
                {totalPage >0 && currentPage < totalPage && (<link rel="next" href={`${canonical(`${url}/${(currentPage + 1)}`, "", "tags")}`} />)}
            </Helmet>
            <div className="big">
                {this.props.mediasLoading && (
                    <LoadingBar />
                )}
                {this.props.mediasTagInitialized && !this.props.mediasTagLoading && (
                    <div className="thumbs-grid">

                        {this.props.mediasTagTotal !== 0 && this.props.slugUser && (
                            <h3 className={"w-100 flex-jc-sb"}>
                                Contenu de : {this.props.mediasTag && this.props.mediasTag[0] && this.props.mediasTag[0].owner && this.props.mediasTag[0].owner.username}
                                <Button to={this.aqp.queryUrl(this.state.filter).link+"/all"}
                                        className={"mr-8 primary small"}
                                        size={"small"}
                                        btnStyle={"primary"}
                                        content={"Voir tout"}
                                />
                            </h3>
                        )}
                        {this.props.mediasTag.map((media) => (
                            <Thumb key={media._id} {...media} cropTitle={45} />
                        ))}

                        {this.props.mediasTagTotal === 0 && this.props.slugUser && this.props.mediasTotal >0 && (
                            <div className={"no-content"}>Il n'y a aucune {this.props.type === "gallery" ? "galerie" : "vidéo"}</div>
                        )}
                        {this.props.mediasTagTotal !== 0 && this.props.slugUser && (
                            <h4 className={"w-100 mt-24"}>Découvrez d'autres {this.props.type === "video" ? "vidéos" : "photos"} de Voissanautes avec le tag "{this.props.tag && this.props.tag.title}"</h4>
                        )}
                    </div>
                )}
                {this.props.mediasInitialized && !this.props.mediaLoading && (
                    <div className="thumbs-grid">
                        {this.props.medias.map((media) => (
                            <Thumb key={media._id} {...media} cropTitle={45} />
                        ))}
                        {this.props.mediasTotal === 0 && (
                            <div className={"no-content"}>Il n'y a aucune {this.props.type === "gallery" ? "galerie" : "vidéo"}</div>
                        )}
                    </div>
                )}
                {totalPage > 1 &&
                <Pagination
                    currentPage={this.state.filter.page}
                    pagesCount={totalPage}
                    handleChangePage={this.handleChangePage}
                    {...this.aqp.queryUrl(this.state.filter)}
                />
                }
            </div>
        </div>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        medias : state.medias.data,
        mediasTotal : state.medias.total,
        mediasInitialized : state.medias.initialized,
        mediasLoading : state.medias.loading,

        mediasTag : state.mediasTag.data,
        mediasTagTotal : state.mediasTag.total,
        mediasTagInitialized : state.mediasTag.initialized,
        mediasTagLoading : state.mediasTag.loading,

    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchMedias,
    fetchMediasTag,
    resetMediasTag,
    resetMedias
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(Medias);
